import { EventEmitter } from 'events';

export class Sticky extends EventEmitter {
  text: string;

  constructor(text: string) {
    super();
    this.text = text;
  }

  remove(): void {
    this.emit('remove');
  }

  update(newText: string): void {
    this.text = newText;
    this.emit('update');
  }
}
